export const privacyCookieModalSeenKey = 'privacyCookieModalSeen';
export var PERSIST_KEY;
(function (PERSIST_KEY) {
    PERSIST_KEY["PURPOSE_LIMITATIONS"] = "persist:purposeLimitations";
    PERSIST_KEY["CONTEXT_FRAMES"] = "persist:contextFrames";
    PERSIST_KEY["ROOT"] = "persist:nike-privacy";
})(PERSIST_KEY || (PERSIST_KEY = {}));
export const allowedCountriesWithCPRA = ['US'];
export const allowedCountriesWithNikePrivacy = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CA',
    'CZ',
    'DK',
    'FI',
    'GR',
    'HU',
    'IE',
    'LU',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'GB',
    'IL',
    'ZA',
    'TR',
    'US',
    'IT',
    'DE',
    'FR',
    'SG',
    'ID',
    'MX',
    'MY',
    'VN',
    'PH',
    'IN',
    'TH',
    'AU',
    'JP',
    'KR',
    'TW',
];
export const THIRTEEN_MONTHS_IN_MILLISECONDS = 34276608000;
export const THIRTEEN_MONTHS_RE_PROMPT_COUNTRIES = [
    'AT',
    'BE',
    'BG',
    'CH',
    'CZ',
    'DE',
    'DK',
    'ES',
    'FI',
    'FR',
    'GB',
    'GR',
    'HR',
    'HU',
    'IE',
    'IT',
    'LU',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
];
export const SQ_COOKIE_EXPIRATION_TIME = new Date(new Date().getTime() + 86400000);
export const COOKIE_PURPOSE_LIMITATIONS_EXPIRATION_PERIOD = 395;
export const SUBDOMAIN_HOST_NAME = '.nike.com';
export const ROUTES_WITH_EXTRA_PRIVACY_PARAM = ['privacy', 'do-not-share-my-data'];
export var LOG_LABEL_STYLES;
(function (LOG_LABEL_STYLES) {
    LOG_LABEL_STYLES["INFO"] = "color:white;background-color:orange;padding:5px";
    LOG_LABEL_STYLES["ERROR"] = "color:white;background-color:red;padding:5px";
})(LOG_LABEL_STYLES || (LOG_LABEL_STYLES = {}));
export const CLEAR_BROWSER_STORAGE_MESSAGE = 'All browser storage related to privacy-core is cleared';
export const countriesWhereSqCookieIsDeprecated = [
    'AT',
    'BE',
    'CZ',
    'DK',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LU',
    'NL',
    'PL',
    'PT',
    'SI',
    'ES',
    'SE',
    'BG',
    'HR',
    'NO',
    'RO',
    'SK',
    'CH',
    'GB',
];
